import { graphql } from '@/generated/gql';

export const INTAKE_REQUEST_LINE_ITEM_QUERY = graphql(/* GraphQL */ `
  query IntakeRequestLineItems($id: UUID!) {
    sevenbridges {
      chatSession(id: $id) {
        id
        status
        request {
          id
          currency
          commodityGroupId
          lineItems {
            id
            sequence
            position
            title
            description
            quantity
            expectedPricePerUnit
            unitId
            earlyDeliveryAt
            lateDeliveryAt
            commodityGroupId
          }
        }
        requirementsExtraction {
          id
          extractedData
          enhancedData
          processingStatus
        }
      }
    }
  }
`);
